import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import MeetUs from '@/pages/meet-us/meet-us'
import GettingStarted from '@/pages/getting-started/getting-started'
import TreatmentOptions from '@/pages/treatment-options/treatment-options'
import Accessibility from '@/pages/accessibility/accessibility'
import ThankYou from '@/pages/thank-you/thank-you'
// import PageNotFound from '@/pages/404/404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/meet-us',
      name: 'Meet Us',
      component: MeetUs,
      navigation: true
    },
    {
      path: '/getting-started',
      name: 'Getting Started',
      component: GettingStarted,
      navigation: true
    },
    {
      path: '/treatment-options',
      name: 'Treatment Options',
      component: TreatmentOptions,
      navigation: true
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      component: Accessibility,
      navigation: false
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      component: ThankYou,
      navigation: false
    },
    {
      path: '/*',
      name: 'home',
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js